export default class Tabs {
  constructor () {
    this.tabs = document.querySelector('.tabs')
    if (this.tabs) {
      this.targetActive = this.tabs.dataset.targetActive
      this.currentItem = null
      this.currentPanel = null
      this.initList()
    }
  }

  /**
   * Test mediaquery (mobile and tablet)
   * @returns {Boolean}
   */
  isMobileTablet () {
    return window.matchMedia('(max-width: 992px)').matches
  }

  /**
   * initial tabs (active li + panel default and add event click for each item)
   */
  initList () {
    this.tabs.querySelectorAll('.tabs__list .tabs__item').forEach(item => {
      const panelInit = this.tabs.querySelector('#' + item.dataset.target)

      // if mobile copy panel into item li
      if (this.isMobileTablet()) {
        if (panelInit) {
          // stopPropagation Event to prevent the item from closing again
          panelInit.addEventListener('click', (e) => { e.stopPropagation() })
          // appen item li
          item.append(panelInit)
        }
      }

      if (this.targetActive === item.id) {
        this.activeItem(item)
        this.showPanel(panelInit)
      }

      // Event
      item.addEventListener('click', (e) => {
        e.preventDefault()
        const panel = this.tabs.querySelector('#' + e.currentTarget.dataset.target)
        if (e.currentTarget.classList.contains('is-active')) {
          this.desactiveItem(e.currentTarget)
          this.hidePanel(panel)
          AOS.init({disable: 'mobile'});
        } else {
          this.desactiveItem(this.currentItem)
          this.hidePanel(this.currentPanel)
          this.activeItem(e.currentTarget)
          this.showPanel(panel)
          AOS.init({disable: 'mobile'});
        }
      })
    })
  }

  /**
   * active tab li
   * @param {HTMLElement} item tab li
   */
  activeItem (item) {
    item.classList.add('is-active')
    item.setAttribute('aria-selected', true)
    this.currentItem = item
  }

  /**
   * desactive current tab li
   */
  desactiveItem (item) {
    if (item) {
      item.classList.remove('is-active')
      item.setAttribute('aria-selected', false)
    }
  }

  /**
   * hide current panel
   */
  hidePanel (panel) {
    if (panel) {
      panel.classList.remove('is-visible')
      panel.setAttribute('aria-hidden', true)
    }
  }

  /**
   *  show panel
   * @param {HTMLElement} panel
   */
  showPanel (panel) {
    if (panel) {
      panel.classList.add('is-visible')
      panel.setAttribute('aria-hidden', false)
      this.currentPanel = panel
    }
  }
}
